// ÁSZF és adatkezelési tájékoztató.
//
// FIGYELEM: EZ A SZÖVEG NEM MENT ÁT JOGI ÁTNÉZÉSEN. A dokumentum ettől még
// hatályosként jelenik meg a látogatónak, mert az App Store bírálata erre az
// oldalra hivatkozik — egy „tervezet" feliratú tájékoztató pont azt ásná alá,
// amit igazolnia kell. A nyitott pontokat tehát NEM a forrás jelöli: azokat
// külön kell számontartani, és a jogi átnézés után itt pontosítani.
//
// MIÉRT NINCS FORDÍTVA. A többi képernyő a szótárból (`t()`) dolgozik, ez
// nem. Egy magyar cég ÁSZF-je és adatkezelési tájékoztatója magyar jog
// szerinti dokumentum; az angol „fordítás" nem ugyanaz a jognyilatkozat, és
// félrevezető lenne egyenrangúként mutatni. Ha kell angol változat, az külön
// jogi munka, nem szótárbejegyzés.
//
// A TARTALOM A TERMÉK TÉNYLEGES MŰKÖDÉSÉT írja le: 7 napos próba, seat-alapú
// díjszabás, Stripe-fizetés, 30 napos türelmi idő írás-tiltással, zárolás,
// és hogy törlés csak emberi döntésre történik. Ezek nem feltételezések — a
// `subscription.js`, a `stripe-billing.js` és a `firestore.rules` ezt csinálja.

import { h } from '../lib/dom';

/// Az adatkezelő azonosító adatai. Egy helyen, mert mindkét oldalon kell.
const CEG = {
  nev: 'BLAZE DATA SOLUTION Kft.',
  szekhely: '7636 Pécs, Gadó utca 8. TT 7. ajtó',
  cegjegyzek: '02-09-088407',
  adoszam: '32583016-2-02',
  email: 'balazs.lang@blazedata.hu',
};

function fejlec(cim: string, frissitve: string): HTMLElement {
  return h(
    'div',
    { class: 'col g8' },
    h('h1', { text: cim }),
    h('span', { class: 'caption', text: `Utolsó frissítés: ${frissitve}` }),
  );
}

function adatkezeloBlokk(): HTMLElement {
  return h(
    'div',
    { class: 'card col g4' },
    h('strong', { text: CEG.nev }),
    h('span', { class: 'caption', text: `Székhely: ${CEG.szekhely}` }),
    h('span', { class: 'caption', text: `Cégjegyzékszám: ${CEG.cegjegyzek}` }),
    h('span', { class: 'caption', text: `Adószám: ${CEG.adoszam}` }),
    h('a', { class: 'caption', href: `mailto:${CEG.email}`, text: CEG.email }),
  );
}

function szakasz(cim: string, ...bekezdesek: (string | HTMLElement)[]): HTMLElement {
  return h(
    'section',
    { class: 'col g8' },
    h('h3', { text: cim }),
    ...bekezdesek.map((b) =>
      typeof b === 'string' ? h('p', { style: { margin: '0' }, text: b }) : b,
    ),
  );
}

function keret(...tartalom: HTMLElement[]): HTMLElement {
  return h(
    'div',
    { class: 'col', style: { minHeight: '100%', background: 'var(--bg)' } },
    h(
      'main',
      {
        class: 'col g24',
        style: { maxWidth: '760px', margin: '0 auto', padding: '32px 16px 64px' },
      },
      h('a', { class: 'caption', href: '#/', text: '← Vissza a főoldalra' }),
      ...tartalom,
    ),
  );
}

// ---------------------------------------------------------------------------
// ÁSZF
// ---------------------------------------------------------------------------

export function termsPage(): HTMLElement {
  return keret(
    fejlec('Általános Szerződési Feltételek', '2026. szeptember 29.'),
    adatkezeloBlokk(),

    szakasz(
      '1. A szolgáltatás',
      'A Blaze feladat- és projektkezelő szolgáltatás szakipari csapatoknak. ' +
        'A szolgáltatás böngészőből (app.blazedata.hu) és mobilalkalmazásból érhető el.',
      'A szolgáltatást cégek veszik igénybe. A regisztráló új céget hoz létre, ' +
        'és annak adminisztrátorává válik; a további felhasználókat ő veszi fel.',
    ),

    szakasz(
      '2. Próbaidőszak',
      'A regisztrációt követően a cég 7 napos, díjmentes próbaidőszakot kap. ' +
        'A próbaidőszak alatt a szolgáltatás teljes értékűen használható.',
    ),

    szakasz(
      '3. Díjszabás és férőhelyek',
      'A díj a megvásárolt férőhelyek (seat) száma alapján, havonta fizetendő. ' +
        'Kétféle férőhely létezik: alap férőhely, illetve AI-funkciót is tartalmazó férőhely.',
      'A férőhelyeket a cég adminisztrátora osztja ki a megvásárolt kereten belül. ' +
        'A keret túllépését a rendszer megakadályozza.',
    ),

    szakasz(
      '4. Fizetés',
      'A fizetés a Stripe fizetési szolgáltatón keresztül történik. ' +
        'Kártyaadatok nem haladnak át a szolgáltatás rendszerén, és azokat nem tároljuk.',
    ),

    szakasz(
      '5. Fizetés elmaradása',
      'Ha az esedékes díj nem érkezik meg, a cég 30 napos türelmi időt kap. ' +
        'A türelmi idő alatt az adatok olvashatók és kimenthetők maradnak, ' +
        'de új adat nem rögzíthető.',
      'A türelmi idő letelte után a hozzáférés zárolásra kerül. ' +
        'A zárolás nem jelent adattörlést: az adatok megmaradnak.',
      'Adatot kizárólag a Szolgáltató kifejezett, emberi döntése alapján törlünk — ' +
        'automatikus törlés nem történik.',
    ),

    szakasz(
      '6. Felmondás',
      'Az előfizetés a következő számlázási időszak végére felmondható. ' +
        'A felmondás módja: írásban a ' + CEG.email + ' címen.',
    ),

    szakasz(
      '7. A felhasználó felelőssége',
      'A cég adminisztrátora felel a felhasználók felvételéért és jogosultságaiért, ' +
        'valamint a rögzített adatok jogszerűségéért.',
    ),

    szakasz(
      '8. Jogviták',
      'A szerződésre a magyar jog az irányadó.',
    ),
  );
}

// ---------------------------------------------------------------------------
// Adatkezelési tájékoztató
// ---------------------------------------------------------------------------

export function privacyPage(): HTMLElement {
  return keret(
    fejlec('Adatkezelési tájékoztató', '2026. október 2.'),

    szakasz('Az adatkezelő'),
    adatkezeloBlokk(),

    szakasz(
      'Milyen adatokat kezelünk',
      'Regisztrációkor és a szolgáltatás használata során: név, e-mail-cím, ' +
        'munkakör, valamint a szolgáltatásban rögzített projektek, feladatok, ' +
        'időadatok, megjegyzések és feltöltött fájlok.',
      'Kapcsolatfelvételkor és hibabejelentéskor: az űrlapon megadott név, ' +
        'e-mail-cím és/vagy telefonszám, valamint az üzenet tartalma.',
    ),

    szakasz(
      'Miért és milyen alapon',
      'A szolgáltatás nyújtásához: a szerződés teljesítése (GDPR 6. cikk (1) b) pont).',
      'Kapcsolatfelvétel és hibabejelentés megválaszolásához: a megkeresés ' +
        'megválaszolásához fűződő jogos érdek, illetve az Ön hozzájárulása.',
      'Hirdetési és mérési eszközökhöz: kizárólag az Ön hozzájárulása ' +
        '(GDPR 6. cikk (1) a) pont).',
    ),

    szakasz(
      'Meddig őrizzük',
      'A szolgáltatásban rögzített adatokat az előfizetés fennállása alatt, ' +
        'majd a szerződés megszűnése után a jogszabályi megőrzési ideig kezeljük.',
      'A kapcsolatfelvételi és hibabejelentési üzeneteket az ügy lezárását követően ' +
        'ésszerű ideig őrizzük.',
    ),

    szakasz(
      'Adatfeldolgozók',
      h(
        'ul',
        { style: { margin: '0', paddingLeft: '20px' } },
        h('li', { text: 'Google Ireland Ltd. — tárhely és háttérszolgáltatások (Firebase)' }),
        h('li', { text: 'Stripe Payments Europe, Ltd. — fizetés feldolgozása' }),
        h('li', { text: 'Resend — tranzakciós e-mailek kiküldése' }),
        h('li', { text: 'Anthropic PBC — szöveggenerálás az AI-funkcióhoz' }),
        h('li', { text: 'Railway Corporation — alkalmazás- és adatbázis-tárhely' }),
        h('li', { text: 'Cloudflare, Inc. — DNS és fájltárhely' }),
      ),
    ),

    // AZ AI-FUNKCIÓ SAJÁT SZAKASZT KAP. Az Apple App Review az 5.1.1(i) és
    // 5.1.2(i) irányelvre hivatkozva utasított el egy kiadást, mert az app
    // személyes adatot ad át egy külső AI-szolgáltatónak anélkül, hogy
    // megmondaná, mit, kinek, és engedélyt kérne rá. Kifejezetten kiemelték:
    // a tájékoztatásnak az ADATKEZELÉSI TÁJÉKOZTATÓBAN kell szerepelnie, az
    // ÁSZF nem elég. A felsorolás a `cloudfunctions/ai-capture.js`-ből jön.
    szakasz(
      'AI-alapú feladatfelvétel',
      'Az alkalmazás AI-funkciója a diktált vagy beírt szövegből strukturált ' +
        'feladatlistát állít elő. Ehhez a szöveget továbbítjuk egy külső ' +
        'szolgáltatónak. A továbbítás kizárólag az Ön kifejezett ' +
        'hozzájárulásával történik: az első feldolgozás előtt megkérdezzük, és ' +
        'hozzájárulás nélkül a funkció nem fut.',
      'Továbbított adatok a mobilalkalmazásban: a diktált vagy beírt szöveg, ' +
        'valamint a cégében dolgozó munkatársak neve és belső azonosítója — ' +
        'utóbbi azért, hogy a rendszer a feladatokhoz felelőst tudjon rendelni. ' +
        'A webes felületről kizárólag a beírt szöveg kerül továbbításra.',
      'NEM továbbítunk e-mail-címet, telefonszámot, jelszót, fényképet, ' +
        'csatolmányt és fizetési adatot.',
      'Címzett: Anthropic PBC (Egyesült Államok, anthropic.com). A szolgáltató ' +
        'az adatot kizárólag a válasz előállítására használja, azt az ' +
        'alkalmazással egyenértékű védelemben részesíti, és a vonatkozó ' +
        'kereskedelmi feltételei szerint nem használja fel a modelljei ' +
        'tanítására. Harmadik országba történő továbbítás alapja az Európai ' +
        'Bizottság által elfogadott általános szerződési feltételek.',
      'Az adatkezelés jogalapja az Ön hozzájárulása. A hozzájárulást bármikor, ' +
        'ugyanolyan egyszerűen visszavonhatja az alkalmazás Beállítások ' +
        'képernyőjén. A visszavonás nem érinti a korábbi adatkezelés ' +
        'jogszerűségét, és a visszavonás után az alkalmazás többi funkciója ' +
        'változatlanul használható.',
    ),

    szakasz(
      'Hirdetési és mérési eszközök',
      'Weboldalunkon — kizárólag az Ön „Marketing" süti-hozzájárulása esetén — ' +
        'külső szolgáltatók hirdetési és mérési eszközeit használhatjuk. Ezekkel ' +
        'mérjük hirdetéseink eredményességét, és hirdetést jeleníthetünk meg ' +
        'azoknak, akik korábban meglátogatták oldalunkat. ' +
        'Hozzájárulás nélkül ezek az eszközök nem töltődnek be.',
      'Hozzájárulását bármikor visszavonhatja az oldal láblécében található ' +
        '„Süti-beállítások" hivatkozáson, ugyanolyan egyszerűen, ahogy megadta. ' +
        'A visszavonás nem érinti a korábbi adatkezelés jogszerűségét.',
      'Kezelt adatok: süti- és eszközazonosítók, IP-cím, böngésző- és eszközadatok, ' +
        'a meglátogatott oldalak és az azokon végzett műveletek.',
      'Harmadik országba történő továbbítás: a szolgáltatók az adatokat az Európai ' +
        'Gazdasági Térségen kívül, különösen az Egyesült Államokban is kezelhetik. ' +
        'Ennek alapja az EU–USA adatvédelmi keretrendszer szerinti tanúsítás, ' +
        'illetve az Európai Bizottság által elfogadott általános szerződési feltételek.',
    ),

    szakasz(
      'Az Ön jogai',
      'Kérhet hozzáférést, helyesbítést, törlést, az adatkezelés korlátozását és ' +
        'adathordozhatóságot, tiltakozhat az adatkezelés ellen, és bármikor ' +
        'visszavonhatja hozzájárulását. Kérését a ' + CEG.email + ' címen jelezheti.',
      'Panasszal a Nemzeti Adatvédelmi és Információszabadság Hatósághoz fordulhat ' +
        '(1055 Budapest, Falk Miksa u. 9–11., naih.hu), illetve bírósághoz is.',
    ),
  );
}
